import React, { useState, useEffect } from 'react';
import API from '../../utils/api';
import './LeadManagementView.css';

function LeadManagementView() {
  const [leads, setLeads] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    course: '',
    status: 'New',
    source: '',
    notes: ''
  });

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    try {
      const res = await API.get('/api/admin/leads');
      setLeads(res.data);
    } catch (error) {
      console.error('Error fetching leads:', error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post('/api/admin/leads', formData);
      setShowModal(false);
      setFormData({ name: '', email: '', phone: '', course: '', status: 'New', source: '', notes: '' });
      fetchLeads();
    } catch (error) {
      console.error('Error adding lead:', error);
      alert('Failed to add lead');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this lead?')) {
      try {
        await API.delete(`/api/admin/leads/${id}`);
        fetchLeads();
      } catch (error) {
        console.error('Error deleting lead:', error);
      }
    }
  };

  const updateStatus = async (id, newStatus) => {
    try {
      await API.put(`/api/admin/leads/${id}`, { status: newStatus });
      fetchLeads();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  return (
    <div className="admin-view lead-management">
      <div className="header-flex">
        <h2>Lead Management</h2>
        <button className="add-btn" onClick={() => setShowModal(true)}>+ Add Lead</button>
      </div>

      <div className="table-box mt-4">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>Course</th>
              <th>Status</th>
              <th>Source</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {leads.length > 0 ? leads.map((lead) => (
              <tr key={lead._id}>
                <td>{lead.name}</td>
                <td>{lead.phone}</td>
                <td>{lead.course}</td>
                <td>
                  <select
                    value={lead.status}
                    onChange={(e) => updateStatus(lead._id, e.target.value)}
                    className={`status-select ${lead.status.toLowerCase()}`}
                  >
                    <option value="New">New</option>
                    <option value="Contacted">Contacted</option>
                    <option value="Interested">Interested</option>
                    <option value="Enrolled">Enrolled</option>
                    <option value="Closed">Closed</option>
                  </select>
                </td>
                <td>{lead.source}</td>
                <td>
                  <button className="action-btn delete-btn" onClick={() => handleDelete(lead._id)}>Delete</button>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>No leads found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Add New Lead</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name *</label>
                <input type="text" name="name" required value={formData.name} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="email" name="email" value={formData.email} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Phone *</label>
                <input type="text" name="phone" required value={formData.phone} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Course Interested</label>
                <input type="text" name="course" value={formData.course} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Status</label>
                <select name="status" value={formData.status} onChange={handleInputChange}>
                  <option value="New">New</option>
                  <option value="Contacted">Contacted</option>
                  <option value="Interested">Interested</option>
                  <option value="Enrolled">Enrolled</option>
                  <option value="Closed">Closed</option>
                </select>
              </div>
              <div className="form-group">
                <label>Source</label>
                <input type="text" name="source" placeholder="e.g. Facebook, Google, Referral" value={formData.source} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Notes</label>
                <textarea name="notes" value={formData.notes} onChange={handleInputChange}></textarea>
              </div>
              <div className="modal-actions">
                <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>Cancel</button>
                <button type="submit" className="save-btn">Save Lead</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default LeadManagementView;
